import queryString from 'query-string';
import objectassign from 'core-js/fn/object/assign';

const UrlHelper = {};

UrlHelper.updateQueryString = (url, qs) => {
    if (!url) {
        return url;
    }

    qs = qs || {};
    const parsedUrl = queryString.parseUrl(url);
    objectassign(parsedUrl.query, qs);

    let newQS = queryString.stringify(parsedUrl.query) || '';
    if (newQS) {
        newQS = '?' + newQS;
    }

    const newUrl = `${parsedUrl.url}${newQS}`;
    return newUrl;
};

window.UrlHelper = UrlHelper;

export { UrlHelper };


// WEBPACK FOOTER //
// ./src/nams2020/common/utils/UrlHelper.js